// extracted by mini-css-extract-plugin
export var locationCard = "_d6-0";